import React, { Component } from 'react';
import './VisualDesigner.css';
import './VisualDesignerRes.css';

const VisualDesigner = () => {
    return ( 

        <>
        <h1 className='Des'>Visual Designer</h1>
        
        
        </>
     );
}
 
export default VisualDesigner;